import * as React from 'react';

import { G, useForm, useTranslation, ValidationBuilder } from '@components';
import { IDocument, documentKindOptions } from '@models/documents';

export interface IProps {
    document: IDocument;
    folderId?: number;
    loading?: boolean;
    onCancel?: Function;
    onSave?: Function;
    workId: number;
}

type IFileFormData = {
    name: string;
    title?: string;
    description?: string;
    folderId?: number;
    workId: number;
}


export function EditDocumentForm(props: IProps) {
    const { t } = useTranslation();
    const form = useForm<IFileFormData>({
        initialValues: props.document,
        validate: d => ValidationBuilder
            .create(d)
            .customValidations([
                {
                    name: 'sortOrder',
                    msg: t('SortOrderMustBeGreaterThanZero'),
                    validation: (d: any) => d.sortOrder > 0,
                }
            ])
            .build()
        ,
    });

    const selectedFile = React.useRef<File | undefined>();

    const handleFile = (e: any) => {
        e.persist();
        const files = e.target.files;
        if (files.length > 0) {
            selectedFile.current = files[0];
            form.setFieldValue('name', files[0].name);
        }
    }

    const handleSave = (...e: any[]) => {
        props.onSave?.(form.values, selectedFile.current);
    }

    return <div>
        <div className={'c md pd g-20 l300'}>
            <G label={t('document.name')}>
                {form.span('name', { autoFocus: true })}
            </G>
            <G label={t('Title')}>
                {form.input('title')}
            </G>
            <G label={t('document.code')}>
                {form.input('code')}
            </G>
            <G label={t('Edition')}>
                {form.input('edition')}
            </G>
            <G label={t('Year')}>
                {form.input('year', { type: 'number' })}
            </G>
            <G label={t('Order')}>
                {form.input('sortOrder', { type: 'number' })}
            </G>
            <G label={t('document.permissions')}>
                {form.select('documentKind', {
                    blank: true,
                    options: documentKindOptions,
                })}
            </G>
            <G label={t('File')}>
                <div className={'sm pd e'}>
                    <input type={'file'} onChange={handleFile} />
                </div>
            </G>

            {form.errorBox()}
        </div>

        <div className={'footer r r-end'}>
            {props.onCancel && <button onClick={() => props.onCancel?.()}>{t('Cancel')}</button>}
            {props.onSave && <button
                className={'primary'}
                disabled={props.loading || form.isInvalid()}
                onClick={handleSave}>{t('Save')}</button>}
        </div>
    </div>
}
